"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5739],{

/***/ 95739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pro_tools; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/LandingPage/index.ts + 8 modules
var LandingPage = __webpack_require__(55781);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/features/pro-tools/constants.ts
var constants = __webpack_require__(23443);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
;// CONCATENATED MODULE: ./src/global/StyleDefinition/Color/index.ts
var color = {
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7"
};
/* harmony default export */ var Color = (color);

;// CONCATENATED MODULE: ./src/features/pro-tools/PricingPlan/constants.ts
var plans = [
    {
        key: "one-month",
        per: "1 Bulan",
        description: "Ideal untuk pemula",
        price: "250.000"
    },
    {
        key: "two-months",
        per: "2 Bulan",
        description: "Untuk yang siap berinvestasi",
        price: "200.000"
    },
    {
        key: "three-months",
        per: "3 Bulan",
        description: "Favorit investor di Stockbit",
        price: "150.000"
    },
    {
        key: "free",
        per: "Free",
        description: "Dengan membuka akun trading di Stockbit",
        price: 0
    }, 
];
/* harmony default export */ var PricingPlan_constants = (plans);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/pro-tools/PricingPlan/styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 60px;\n  font-size: 36px;\n\n  @media ",
        " {\n    font-size: 6.5vh;\n  }\n\n  @media ",
        " {\n    font-size: 44px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  padding: 32px 20px;\n  border: solid 1px ",
        ";\n  border-radius: 2px;\n  font-size: 17px;\n  flex: 1;\n  width: 100%;\n  margin-bottom: 50px;\n  @media ",
        " {\n    height: 340px;\n    margin: 0 70px 0 0;\n    &:last-child {\n      margin: 0;\n    }\n  }\n\n  & > div {\n    text-align: center;\n    width: 100%;\n    display: block;\n\n    &:first-child {\n      margin-bottom: 60px;\n    }\n  }\n\n  &:last-child {\n    background: rgba(0, 171, 107, 0.05);\n    box-shadow: 4px 4px 0 ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  max-width: 1000px;\n  margin: auto;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 50px);\n  margin: 50px auto;\n  @media ",
        " {\n    max-width: 1300px;\n    width: calc(100% - 150px);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 10px 20px;\n  text-transform: uppercase;\n  width: 100%;\n  display: block;\n  margin-top: 15px;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  @media ",
        " {\n    font-size: 17px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 22px;\n  @media ",
        " {\n    font-size: 30px;\n  }\n\n  &.price {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Text = ui/* Common.Text */.Gn.Text, Flex = ui/* Common.Flex */.Gn.Flex;
var Subtitle = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "h3",
    family: "bold",
    color: ui/* color.primary */.$_.primary,
    align: "center",
    size: "26px"
}).withConfig({
    componentId: "sc-410f0633-0"
})(_templateObject());
var Title = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "h1",
    family: "bold",
    align: "center"
}).withConfig({
    componentId: "sc-410f0633-1"
})(_templateObject1(), ui/* device.laptop */.Uh.laptop, ui/* device.laptopL */.Uh.laptopL);
var Box = (0,styled_components_browser_esm["default"])(Flex).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-410f0633-2"
})(_templateObject2(), ui/* color.downgray */.$_.downgray, ui/* device.laptop */.Uh.laptop, ui/* color.primary */.$_.primary);
var BoxContainer = (0,styled_components_browser_esm["default"])(Flex).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-410f0633-3"
})(_templateObject3(), ui/* device.laptop */.Uh.laptop);
var PlanContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-410f0633-4"
})(_templateObject4(), ui/* device.tablet */.Uh.tablet);
var Button = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "a",
    align: "center",
    color: ui/* color.light */.$_.light,
    family: "bold"
}).withConfig({
    componentId: "sc-410f0633-5"
})(_templateObject5(), ui/* color.primary */.$_.primary, ui/* color.light */.$_.light, ui/* device.laptop */.Uh.laptop);
var BigText = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "span",
    align: "center",
    color: ui/* color.primary */.$_.primary,
    family: "bold"
}).withConfig({
    componentId: "sc-410f0633-6"
})(_templateObject6(), ui/* device.laptop */.Uh.laptop);

;// CONCATENATED MODULE: ./src/features/pro-tools/PricingPlan/index.tsx






var PricingPlan_Text = ui/* Common.Text */.Gn.Text;
var PricingPlan = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PlanContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                children: "Pricing Plan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "Berbagai pilihan berlangganan terbaik untuk mendukung kegiatan investasimu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxContainer, {
                children: PricingPlan_constants.map(function(plan) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BigText, {
                                        children: plan.per
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingPlan_Text, {
                                        as: "p",
                                        size: "17px",
                                        align: "center",
                                        children: plan.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingPlan_Text, {
                                        as: "span",
                                        size: "17px",
                                        children: "Rp"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BigText, {
                                        className: "price",
                                        children: plan.price
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingPlan_Text, {
                                        color: Color.midgray,
                                        as: "p",
                                        size: "12px",
                                        align: "center",
                                        children: "per bulan"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/register",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                            children: "Subscribe"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, plan.key);
                })
            })
        ]
    });
};
/* harmony default export */ var pro_tools_PricingPlan = (PricingPlan);

// EXTERNAL MODULE: ./src/features/pro-tools/styled.ts
var styled = __webpack_require__(12957);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/features/pro-tools/uikit/Scrollspy/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  display: none;\n  padding: 15px 0;\n  position: fixed;\n  top: 0;\n  transition: all 0.2s ease;\n  width: 100%;\n  z-index: 0;\n\n  &.down {\n    top: 80px;\n    z-index: 5;\n  }\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  list-style: none;\n  max-width: 1300px;\n\n  @media ",
        " {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    margin: auto;\n    width: calc(100% - 151px);\n  }\n\n  li {\n    a {\n      color: ",
        ";\n      font-size: 16px;\n      font-family: var(--regular-font);\n      text-decoration: none;\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n\n    &.active {\n      a {\n        color: ",
        ";\n        font-family: var(--bold-font);\n      }\n    }\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styled_Flex = ui/* Common.Flex */.Gn.Flex;
var Wrapper = styled_components_browser_esm["default"].nav.withConfig({
    componentId: "sc-85349af-0"
})(styled_templateObject(), ui/* color.light */.$_.light, ui/* device.laptop */.Uh.laptop);
var ContentWrapper = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    as: "ul"
}).withConfig({
    componentId: "sc-85349af-1"
})(styled_templateObject1(), ui/* device.laptop */.Uh.laptop, ui/* color.darkGrey */.$_.darkGrey, ui/* color.highempahis */.$_.highempahis, ui/* color.highempahis */.$_.highempahis);


;// CONCATENATED MODULE: ./src/features/pro-tools/uikit/Scrollspy/index.tsx



function ScrollSpy(param) {
    var children = param.children;
    var handleClick = function(element, e) {
        e.preventDefault();
        var spiedComponent = document.getElementById("".concat(element.dataset.spy));
        window.scrollTo({
            top: spiedComponent.offsetTop,
            left: 0,
            behavior: "smooth"
        });
    };
    var handleScroll = function() {
        var tabList = document.querySelectorAll("li[data-spy]");
        tabList.forEach(function(list) {
            var spiedComponent = document.getElementById("".concat(list.dataset.spy));
            var link = list.querySelector("a");
            if (spiedComponent) {
                if (window.scrollY >= spiedComponent.offsetTop) {
                    document.querySelector(".active").classList.remove("active");
                    list.classList.add("active");
                }
            } else {
                return;
            }
            // @ts-ignore
            link.addEventListener("click", function(event) {
                return handleClick(list, event);
            });
        });
    };
    var handleToggleActive = function() {
        var scrollSpy = document.getElementById("scroll-spy");
        var scrollY = window.scrollY;
        var isActive = scrollSpy.classList.contains("down");
        if (scrollY < 450) {
            scrollSpy.classList.remove("down");
        } else if (!isActive) {
            scrollSpy.classList.add("down");
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleToggleActive);
        return function() {
            window.removeEventListener("scroll", handleToggleActive);
        };
    }, []);
    // scroll spy effect
    (0,react.useEffect)(function() {
        var tabList = document.querySelectorAll("li[data-spy]");
        tabList[0].classList.add("active");
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        id: "scroll-spy",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
            children: children
        })
    });
}
/* harmony default export */ var Scrollspy = (ScrollSpy);

;// CONCATENATED MODULE: ./src/features/pro-tools/index.tsx








function ProTools() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* HeaderWrapper */.Pz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* HeaderTitle */.Gh, {
                                children: [
                                    "Professional Tools",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "untuk Pemula"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/register",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonInvest */.R3, {
                                    children: "Buka Rekening Anda"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "illustration",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/pro1.svg",
                            alt: "pro tools illustration",
                            style: {
                                width: "100%"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Scrollspy, {
                children: constants/* toolsFeatures.map */.$.map(function(feat) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        "data-spy": feat.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#".concat(feat.url),
                            children: feat.title
                        })
                    }, feat.title);
                })
            }),
            constants/* toolsFeatures.map */.$.map(function(feature) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* SectionContent */.ZG, {
                    id: feature.url,
                    title: feature.title,
                    label: feature.description,
                    url: "/info/pro-tools/".concat(feature.url),
                    icon: "/images/".concat(feature.icon),
                    features: feature.features
                }, feature.url);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pro_tools_PricingPlan, {})
        ]
    });
}
/* harmony default export */ var pro_tools = (ProTools);


/***/ }),

/***/ 12957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Gh": function() { return /* binding */ HeaderTitle; },
/* harmony export */   "Pz": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "R3": function() { return /* binding */ ButtonInvest; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "xj": function() { return /* binding */ AdditionalWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 50px;\n  margin: auto;\n  padding: 0 25px;\n  width: 100%;\n  max-width: 940px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 100px;\n    padding: 0;\n    width: calc(100% - 151px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin: auto;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    text-align: left;\n    margin: unset;\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  margin: auto;\n  text-align: center;\n\n  @media ",
        " {\n    margin: unset;\n    text-align: left;\n  }\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  flex-direction: column;\n  margin: 100px auto;\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  .title-wrapper,\n  .illustration {\n    width: 100%;\n  }\n\n  .title-wrapper {\n    margin-bottom: 70px;\n  }\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n    margin: 130px auto;\n    padding: 50px 0;\n    width: calc(100% - 151px);\n\n    .title-wrapper,\n    .illustration {\n      margin-bottom: 0;\n    }\n\n    .title-wrapper {\n      width: 40%;\n      padding-right: 50px;\n    }\n    .illustration {\n      width: 60%;\n      padding-left: 50px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  color: ",
        ";\n  cursor: pointer;\n  font-family: var(--bold-font);\n  font-size: 18px;\n  height: 50px;\n  margin: auto;\n  margin-bottom: 50px;\n  padding: 0 20px;\n  text-transform: uppercase;\n  width: fit-content;\n  max-width: 100%;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  @media ",
        " {\n    margin: 0;\n    margin-bottom: 9vh;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 30px;\n  margin: auto;\n  margin-bottom: 20px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 60px;\n    margin-bottom: 60px;\n  }\n\n  @media ",
        " {\n    margin: 0;\n    margin-bottom: 60px;\n    text-align: left;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex;
var AdditionalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-f0d3870b-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    as: "h2",
    size: "40px",
    family: "bold"
}).withConfig({
    componentId: "sc-f0d3870b-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    height: 1.3,
    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimgray */ .$_.dimgray
}).withConfig({
    componentId: "sc-f0d3870b-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var HeaderWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-f0d3870b-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var ButtonInvest = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    as: "a",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f0d3870b-4"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var HeaderTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    as: "h1",
    family: "bold",
    height: 1.3
}).withConfig({
    componentId: "sc-f0d3870b-5"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);



/***/ })

}]);